// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../src-custom-solutions/president-election/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".headline-author-wrapper{margin:15px 0 0 0;line-height:15px}@media(max-width:991.98px){.headline-author-wrapper{margin:0 0 15px 0}}.headline-author{display:inline;margin:0;font-family:var(--font-family-system);font-size:10px;font-weight:600;line-height:15px;vertical-align:top}", ""]);
// Exports
module.exports = exports;
